import React from "react";
import { injectGlobal } from "styled-components";

import { CFontIcon } from "@appcues/component-library";

import AppcuesWidget from "appcues-widget";

injectGlobal`
    .appcues-widget-dropdown.appcues-widget-fixed.appcues-widget-top-right {
      font-family: 'Muli',Arial,sans-serif;
      position: fixed;
      margin-left: 65px;
      background: #ffffff;
      border-radius: 6px;
      padding: 10px;
      transform: translateY(-30%);
      &:after, &:before {
        left: -10px;
        top: 70%;
        border: solid transparent;
        content: "";
        height: 0;
        width: 0;
        position: absolute;
        pointer-events: none;
      }
      &:after {
        border-right-color: #ffffff;
        border-width: 10px;
        margin-top: -10px;
      }
      
    }

    .appcues-widget-header-text {
      font-size: 24px;
      font-weight: 400;
    }

    .appcues-widget-header {
      border-bottom: 0;
    }

    .appcues-widget-container {
      li.appcues-nothing-new {
        display: none;
      }
      a[data-itemid] time {
        display: none;
      }
    }
    .appcues-widget-icon {
      opacity: 1; /* override widget fade-in */
      margin-left: 15px;
      &:hover {
        color: #5C5CFF; /* no access to theme */
        .svg-inline--fa path {
          fill: #5C5CFF;
        }
      }
      &.appcues-icon-visible::before {
        font-size: 15px;
        width: 100px;
        content: 'Resources';
        font-family: 'Muli',Arial,sans-serif;
        position: absolute;
        left: 25px;
        top: 7px;
      }
      .svg-inline--fa {
        width: .5em
      }
    }

`;

const WidgetLink = () => {
  if (!window.Appcues) {
    return null;
  }

  const widget = AppcuesWidget(window.Appcues.user());

  widget.init("#widget-root", {
    position: "top-right",
    header: "<h2 class='appcues-widget-header-text'>Resources</h2>"
  });

  return (
    <li id="widget-root">
      <div className="appcues-widget-icon" role="button">
        <CFontIcon fontSize="3" className="fa fa-list" altText="Resources" />
      </div>
    </li>
  );
};

export default WidgetLink;
